import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from 'react-select'
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from 'sweetalert2';
import { formatDate, SubmitButton, TextBox } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import TooltipComponent from "../../Components/TooltipComponent";
import { currentDateAndTime, decodeData, formatDateAndTime } from "../../Constants/constants";
import * as XLSX from 'xlsx'


class MyExpense extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      reporting_manager: '1',
      location_id: "",
      department_id: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      loadingSearch: false,
      loadingLogs: false,
      postLoading: false,
      get_location_row: [],
      goals_rows: [],
      department_row: [],
      selectedEmployeeId: null,
      selectedRows: [],
      agency_verification_status: '',
      empOptions: [],
      emp_keyword: '',
      selected_rm_employee_id: '',
      reporting_manager_employee_id: '',
      assignGoalsModal: false,
      goal_id:"",
      goal_title:"",
      goal_description:"",
      from_date: '',
      to_date: '',
      pms_cycle_start_date: '',
      pms_cycle_end_date: '',
      pms_cycle_from_date: '',
      pms_cycle_to_date: '',
      errors: '',
      goal_assign_id: "",
      goal_rating_employee: "",
      expense_description: "",
     
      goal_status: "",
      sendGoalModal:false,
      viewEmployeeGoalsLogs:false,
    //   employeeGoalsRows: [],
      expenseOptions: [],
      expense_id: "",
      expense_date: "",
      expense_amount: "",
      formData: {
        file: null,
        fileData: null
      },
      viewDocument:false,
      fileView:false,
      employeeExpenseRows: [],
      viewEmployeeExpenseLogs:false,
      decodedData: [],
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
    //   this.GetDepartmentMasters();
    //   this.GetEmployeesOptionList();
    //   this.GetLocationMasters();
      this.GetList();
      this.GetExpenseList();
    //   this.GetLocationList();
    });
  }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
            console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                console.log("encodedData",encodedData);
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                console.log("decodedData",decodedData);
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
                }
            } else {
                console.warn("Permissions not yet available. Retrying...");
            }
        }
    }

  GetEmployeesOptionList = () => {
    if (this.state.emp_keyword) {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
      try {
        axios
          .get(`${apiURL}ExpenseRouter/GetEmployeesOptionList`, { params: { keyword: this.state.emp_keyword }, headers })
          .then((response) => {
            if (response.data.success === true) {
              this.setState({ empOptions: response.data.data })
            } else {
              this.setState({ empOptions: [] })
            }
          })
      } catch (error) {
        console.log("error", error)
      }
    } else {
      console.log("no emp keyword")
    }
  }
  GetExpenseLogList = (row) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}ExpenseRouter/GetMyExpenseLog`, {
        params: {
            employee_expense_id: row?.employee_expense_id || "",
            employee_id: row?.employee_id || "",

        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {           
          this.setState({
            employeeExpenseRows: data?.data,
            viewEmployeeExpenseLogs:row?.expense_title,
          });
        } else {
            Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: 'Opps...! Something went wrong.', 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
            });
        }
      })
      .catch((error)=>{
        console.log(error);
        Swal.fire({ 
            title: `<strong>Failed</strong>`, 
            text: 'Opps...! Something went wrong.', 
            icon: 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });
      })
      .finally(this.setState({ loadingList: false, loadingLogs:false }));
      
  };
  GetExpenseList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}ExpenseRouter/GetExpenseList`, {
        params: {
          limit: 999,
          page: 1,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
            const tempRows= data?.data.map((val)=>{
                return { value: val?.expense_id, label: val?.expense_title }
            })
          this.setState({
            expenseOptions: tempRows,
          });
        } else {
          this.setState({ loadingList: false, loadingSearch:false });
        }
      })
      .catch((error)=>{
        console.log(error);
      })
      .finally(this.setState({ loadingList: false, loadingSearch:false }));
      
  };
  handleRadioChange = (name, value) => {

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));

  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    let errors = {};
    console.log(file);
    if (file) {
        const { name, size, type } = file;
        const fileSizeInMB = size / (1024 * 1024);
        console.log("size", fileSizeInMB);
        errors.required_document = '';
        if (fileSizeInMB > 10) {
            errors.file = "File size exceeds the maximum limit of 10 MB";
            this.setState({ errors });
            console.error("File size exceeds the maximum limit of 10 MB");
            return;
        }
        let newState = {
            fileName: name,
            fileSize: `${fileSizeInMB.toFixed(2)} MB`,
            letterhead: [file],
            errorMessage: errors?.file,
            fileDelete: true
        };

        if (type.startsWith("image/")) {
            newState = {
                ...newState,
                selectedImage: URL.createObjectURL(file),
                fileTypeIcon: "/img/img-logo.png",
            };
        } else {
            newState = {
                ...newState,
                isValidPdfFile: true,
                fileTypeIcon: "/img/pdf-logo.svg",
            };
        }
        console.log(file, newState);
        this.setState({
            errors: { ...errors, file: "" },
            formData: {
                ...this.state.formData,
                file: file,
                fileData: newState
            }
        });
    }
};

handleDeleteImage = () => {
    this.setState({
        formData: {
            ...this.state.formData,
            file: null,
            fileData: null
        }
    });
};

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}ExpenseRouter/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.department;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            department_row: data.map((row) => ({
              value: row.department_id,
              label: row.department_title,
            })),
          }));
        }
      });
  };


  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}ExpenseRouter/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.location;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Location: data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}ExpenseRouter/GetMyExpense`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          department_id: this.state.department_id,
          location_id: this.state.location_id,
        //   expense_status: this.state.reporting_manager_employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        }
        this.setState({ loadingList: false,loadingSearch:false, loadingFilter: false });
    })
    .catch((error)=>{
        this.setState({ loadingList: false,loadingSearch:false, loadingFilter: false });
        console.log(error);
        Swal.fire({ 
        title: `<strong>Failed</strong>`, 
        text: error?.message, 
        icon: 'error', 
        showConfirmButton: true,
        allowOutsideClick:false, 
        });
    });
  };

  handleSubmit = () => {
    const { apiURL, apiHeaderFile } = this.context;
    const headers = apiHeaderFile;
    const errors = this.validateForm();
    console.log("SubmitMyGoalReview ERROR:",errors);
    if (Object.keys(errors).length > 0) {
      this.setState({ errors,postLoading:false });
      return;
    }
    const formData = {
        expense_id: this.state.expense_id || "",
        expense_description: this.state.expense_description,
        expense_date: this.state.expense_date,
        expense_amount: this.state.expense_amount,
        
        
        file: this.state.formData?.file,
        date: currentDateAndTime(),
    };
    this.setState({postLoading:true});
    axios.post(`${apiURL}ExpenseRouter/CreateMyExpense`, formData, { headers })
    .then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({ 
            postLoading:false,
            expense_id:'',
            applyModal:false,
            expense_description: "",
            expense_date: "",
            expense_amount: "",
            formData: null,

           
         }, (prevState) => {
          this.GetList();
        })
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });      
        } else {
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });      
        this.setState({postLoading:false, })
      }
    }).catch((error)=>{
        this.setState({postLoading:false})
        console.log("ERROR",error);
        Swal.fire({ 
            title: `<strong>Failed</strong>`, 
            text: 'Opps...! Something went wrong.', 
            icon: 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });
    });
  };

    validateForm = () => {
        const errors = {};
        if (!this.state.expense_description) errors.expense_description = 'Description is required';    
        if (!this.state.expense_id) {
          errors.expense_id = 'Expense is required';
        }
        if (!this.state.expense_date) {
          errors.expense_date = 'Date is required';
        }
        if (this.state.expense_date && this.state.expense_date > currentDateAndTime() ) {
          errors.expense_date = 'Expense date cannot be greater than current date!';
        }
        if (!this.state.expense_amount) {
          errors.expense_amount = 'Amount is required';
        }
        return errors;
      };

  getInfo=(row)=>{
    let newState = {
        fileName: row?.expense_attachments,
        fileSize: "",
        fileDelete:false,
    };

    if (row?.expense_attachments && row?.expense_attachments.includes("pdf")) {
        newState = {
            ...newState,
            isValidPdfFile: true,
            fileTypeIcon: "/img/pdf-logo.svg",
        };
    } else {
        newState = {
            ...newState,
            // selectedImage: URL.createObjectURL(file),
            fileTypeIcon: "/img/img-logo.png",
        };
    }
    this.setState({
        expense_id: row?.expense_id,
        expense_date: row?.expense_date,
        expense_amount: row?.expense_amount,
        expense_description: row?.expense_description || '',
        formData:{
            file: row?.document_url,
            fileData: newState
        },
        applyModal: true,
        fileView: true
    }, ()=>{
        console.log(this.state.formData);
    });
  }
    handleCancel = (row) => {    
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON
    // setLoading(true);
    Swal.fire({
        title: 'Are you sure?',
        text: "You want to cancel this?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No!',
        input: 'text', 
        inputPlaceholder: 'Enter your remark here...',
        inputAttributes: {
            'aria-label': 'Enter your remark here...', 
        },
        allowOutsideClick:false,
        preConfirm: (remark) => {
            if (!remark) {
                Swal.showValidationMessage('Remark cannot be empty');
            }
            return remark;
        }
    }).then((result) => {
        if (result.isConfirmed && result.value) {
            const data = {
                employee_expense_id:row?.employee_expense_id,
                remarks: result.value,
                date: currentDateAndTime()
            }
            axios
            .post(`${apiURL}ExpenseRouter/CancelMyExpense`, data, {
                headers
            })
            .then(response => {
                const { success } = response.data
                if (success === true) {
                
                this.GetList();
                } 
                console.log("response.data ====>",response.data)
                Swal.fire({
                    title: `<strong>${ response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                    // timerProgressBar: true,
                    // showConfirmButton: false,
                })
            })
            .catch(error => {
                Swal.fire({
                title: `<strong>"Failed"</strong>`,
                text: error?.data?.message,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false
                })
            })
        }
    });
  
  }

// handleCancel = (row) => {    
//     const { apiURL, apiHeaderJSON } = this.context;
//     const headers = apiHeaderJSON;

//     Swal.fire({
//         title: 'Are you sure?',
//         text: "You want to cancel this?",
//         icon: 'warning',
//         showCancelButton: true,
//         confirmButtonText: 'Yes!',
//         cancelButtonText: 'No!',
//         input: 'text', 
//         inputPlaceholder: 'Enter your remark here...',
//         inputAttributes: {
//             'aria-label': 'Enter your remark here...', 
//         },
//         allowOutsideClick: false,
//         preConfirm: (remark) => {
//             if (!remark) {
//                 Swal.showValidationMessage('Remark cannot be empty');
//             }
//             return remark;
//         }
//     }).then((result) => {
//         if (result.isConfirmed && result.value) {
//             const data = {
//                 employee_expense_id: row?.employee_expense_id,
//                 remarks: result.value,
//                 date: currentDateAndTime()
//             };

//             axios.post(`${apiURL}ExpenseRouter/CancelMyExpense`, data, { headers })
//                 .then(response => {
//                     console.log("API Response ====>", response.data);
                    
//                     if (response.data.success) { 
//                         this.GetList(); // Ensure this function doesn't throw an error
//                         Swal.fire({
//                             title: '<strong>Success</strong>',
//                             text: response.data.message,
//                             icon: 'success',
//                             timerProgressBar: true,
//                             showConfirmButton: false,
//                         });
//                     } else {
//                         Swal.fire({
//                             title: '<strong>Failed</strong>',
//                             text: response.data.message || "Something went wrong!",
//                             icon: 'error',
//                             showConfirmButton: true,
//                             allowOutsideClick: false
//                         });
//                     }
//                 })
//                 .catch(error => {
//                     console.error("API Error ====>", error); // Log full error
//                     Swal.fire({
//                         title: '<strong>Failed</strong>',
//                         text: error.response?.data?.message || "An error occurred. Please try again.",
//                         icon: 'error',
//                         showConfirmButton: true,
//                         allowOutsideClick: false
//                     });
//                 });
//         }
//     });
// };

  handleRating=(row)=>{
    this.setState({
        goal_id: row?.goal_id,
        goal_assign_id: row?.goal_assign_id,
        goal_title: row?.goal_title || "",
        pms_cycle_start_date: row?.cycle_from_date? formatDate(row?.cycle_from_date): '',
        pms_cycle_end_date: row?.cycle_to_date? formatDate(row?.cycle_to_date): '',
        pms_cycle_from_date: row.goal_start_date? formatDate(row.goal_start_date):'',
        pms_cycle_to_date:  row.goal_end_date? formatDate(row.goal_end_date):'',
        sendGoalModal:true,
        goal_rating_employee: row?.goal_rating_employee || '',
        expense_description: row?.expense_description || '',
    });
  }

  handleInputSearch = (e) => {
    this.GetList();
    //   this.GetLocationList();
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }),()=>{
        if(!value && name==="keyword"){
            this.GetList();
        }
    });
  };


  handleCheckboxChange = (employeeId) => {
    this.setState((prevState) => {
      const selectedRows = [...prevState.selectedRows];

      if (selectedRows.includes(employeeId)) {
        selectedRows.splice(selectedRows.indexOf(employeeId), 1);
      } else {
        selectedRows.push(employeeId);
      }

      return { selectedRows };
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows = prevState.selectedRows.length === prevState.rows.length
        ? []
        : prevState.rows.map((row) => row.employee_id);

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action,row) => {
    Swal.fire({
        title: 'Are you sure?',
        text: `Do you want to change status to ${action}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No!',
    }).then((result) => {
        if (result.isConfirmed) {
            this.setState({ 
                goal_assign_id: row?.goal_assign_id || "",
                employee_id: row?.employee_id || "",
                goal_status: action==="Started"? "1":"2" },
            ()=> this.handleStatusSubmit());
    }});

  };

  handleStatusSubmit = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const formData = {
        goal_assign_id: this.state.goal_assign_id || "",
        employee_id: this.state.employee_id || "",
        goal_status: this.state.goal_status,
        date: currentDateAndTime(),
    };
    Swal.fire({
        title: 'Please wait...',
        html: 'Processing...',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });
    axios.post(`${apiURL}ExpenseRouter/HandleMyGoalStatus`, formData, { headers })
    .then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({ 
            postLoading:false,
            goal_status:'',
         }, (prevState) => {
          this.GetList();
        })
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });      
        } else {
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });      
        this.setState({postLoading:false, })
      }
    }).catch((error)=>{
            console.log("ERROR",error);
            Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: 'Opps...! Something went wrong.', 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
            });
        }).finally(()=>{
            Swal.close();
            this.setState({postLoading:false});
        });
  };

//   GetGoalsLogList = (row) => {
//     const { apiURL, apiHeaderJSON } = this.context;
//     const headers = apiHeaderJSON;
//     axios
//       .get(`${apiURL}ExpenseRouter/GetAssignedGoalsLogs`, {
//         params: {
//             goal_assign_id: row?.goal_assign_id || "",
//             employee_id: row?.employee_id || "",
//             is_employee: "1",
//         },
//         headers,
//       })
//       .then((response) => {
//         var data = response.data;
//         if (response.data.success === true) {           
//           this.setState({
//             employeeGoalsRows: data?.data,
//             viewEmployeeGoalsLogs:true,
//           });
//         } else {
//             Swal.fire({ 
//                 title: `<strong>Failed</strong>`, 
//                 text: 'Opps...! Something went wrong.', 
//                 icon: 'error', 
//                 showConfirmButton: true,
//                 allowOutsideClick:false, 
//             });
//         }
//       })
//       .catch((error)=>{
//         console.log(error);
//         Swal.fire({ 
//             title: `<strong>Failed</strong>`, 
//             text: 'Opps...! Something went wrong.', 
//             icon: 'error', 
//             showConfirmButton: true,
//             allowOutsideClick:false, 
//         });
//       })
//       .finally(this.setState({ loadingList: false, loadingLogs:false }));
      
//   };

  GetLocationList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetLocationList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            get_location_row: data.data.map((row) => ({
              value: row.location_id,
              label: row.location_title
            }))
          }));
        }
      });
  }

  handleExcelDownload = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    Swal.fire({
        title: 'Please wait...',
        html: 'Your file is being prepared for download.',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });

    axios.get(`${apiURL}ExpenseRouter/GetMyGoalsList`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          department_id: this.state.department_id,
          location_id: this.state.location_id,
          reporting_manager_employee_id: this.state.reporting_manager_employee_id,
        },headers
    }).then(async (response) => {
        // console.log("handleExcelDownload",response);
        if (response.data?.success === true) {
            const rows = response.data?.data;
            const data = rows.map(row => ({
                'Employee Code': row?.employee_code ? row?.employee_code : "-",
                'Employee Name': row?.employee_name ? row?.employee_name : "-",
                'Reporting Manager': row?.reporting_manager_name ? row?.reporting_manager_name : "-",
                'Assigned Date': row?.assigned_date? formatDate(row?.assigned_date):"--",
                'PMS Cycle': `${row?.cycle_from_date? formatDate(row?.cycle_from_date):""} To ${row?.cycle_to_date? formatDate(row?.cycle_to_date):""}`,
                'Goal Start Date': ` ${row?.goal_start_date ? formatDate(row?.goal_start_date) : "-"}`,
                'Goal End Date': `${row?.goal_end_date ? formatDate(row?.goal_end_date) : "-"}`,
                'Task Submitted Date': `${row?.goal_submitted_date ? formatDate(row?.goal_submitted_date) : "-"}`,
                'Goal Title': row?.goal_title ? row?.goal_title : "-",
                // 'Department': row?.department_title ? row?.department_title : "-",
                // 'Location': row?.location_title ? row?.location_title : "-",
                'Status': row?.GoalStatus ? row?.GoalStatus : "-",
                'Employee Rating': row?.goal_rating_employee ? row?.goal_rating_employee : "-",
                'RM Rating': row?.goal_rating_rm ? row?.goal_rating_rm : "-",
                'Grade': row?.goal_grade ? row?.goal_grade : "-",
                'Remark By Employee': row?.expense_description ? row?.expense_description : "-",
                'Remark By RM': row?.goal_rating_remarks_rm ? row?.goal_rating_remarks_rm : "-",
            }));

            const columns = [
                { header:  'Employee Code', key:  'Employee Code', width: 20 },
                { header:  'Employee Name', key:  'Employee Name', width: 20 },
                { header: 'Reporting Manager', key: 'Reporting Manager', width: 20 },
                { header: 'Assigned Date', key: 'Assigned Date', width: 20 },
                { header: 'PMS Cycle', key: 'PMS Cycle', width: 20 },
                { header: 'Goal Start Date', key: 'Goal Start Date', width: 20 },
                { header: 'Goal End Date', key: 'Goal End Date', width: 20 },
                { header: 'Task Submitted Date', key: 'Task Submitted Date', width: 20 },
                { header: 'Goal Title', key: 'Goal Title', width: 20 },
                // { header: 'Department', key: 'Department', width: 20 },
                // { header: 'Location', key: 'Location', width: 20 },
                { header: 'Status', key: 'Status', width: 20 },
                { header: 'Employee Rating', key: 'Employee Rating', width: 20 },
                { header: 'RM Rating', key: 'RM Rating', width: 20 },
                { header: 'Grade', key: 'Grade', width: 20 },
                { header: 'Remark By Employee', key: 'Remark By Employee', width: 20 },
                { header: 'Remark By RM', key: 'Remark By RM', width: 20 },
            ];

            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });
            ws['!cols'] = columns.map(column => ({ wch: column.width }));
            XLSX.utils.book_append_sheet(wb, ws, 'My Goals Report');

            // XLSX.writeFile(wb, `AbStartMyAttendanceReport_(${Date()}).xlsx`);
            const date=currentDateAndTime();
            XLSX.writeFile(wb, `My Goals Report ${formatDate(date)}.xlsx`);

            Swal.close();

            Swal.fire({
                title: '<strong>Success</strong>',
                html: 'Your file has been downloaded successfully.',
                icon: 'success'
            });
        } else {
            Swal.close();
            Swal.fire({
                title: '<strong>Error</strong>',
                html: response.data.message,
                icon: 'error'
            });
        }
    }).catch((error) => {
        Swal.close();
        Swal.fire({
            title: '<strong>Error</strong>',
            html: error.message,
            icon: 'error'
        });
    });
}

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
            if(this.state.rows?.length>0){
                this.GetList();
            }
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
            if(this.state.rows?.length>0){
                this.GetList();
            }
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        if(this.state.rows?.length>0){
            this.GetList();
        }
      }
    );
  };

  handleSelectChange = (name, selectedOption) => {

    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        if(this.state.rows?.length>0){
            this.GetList();
        }
      }
    );
  };
  
  handleClearAll = () => {
    try{
        this.setState(
        {
            location_id: '',
            department_id: '',
            location_shift_id: '',
            reporting_manager_employee_id: '',
            keyword: "",
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            postLoading: false,
            from_date: "",
            to_date: "",
        },
        () => {
            this.GetList();
        }
        );
    } catch (error) {
        this.setState({ loadingFilter: false });
    }
  };

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500,];
    const { formData,fileData, file, errors } = this.state;
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`My Expense`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className='col-md-3'>
                        <label htmlFor="keyword">Search By Title</label>
                        <div className="input-group">
                          <input type="search" className="form-control" 
                          onChange={this.handleInputChange} name="keyword" 
                          value={this.state.keyword} aria-label="Recipient's username" 
                          aria-describedby="button-addon2" placeholder="Enter Title" />
                           {/* <TooltipComponent name="Search" position="bottom"> */}
                            <button className="btn btn-success" 
                            onClick={() => {
                            if ( this.state.keyword && !this.state.loadingSearch ) {
                                this.setState({ loadingSearch:true },()=>{ this.handleInputSearch(); }) }
                            }} type="button" id="button-addon2">
                            {this.state.loadingSearch ? (
                            <span class="spinner-border flex-shrink-0" role="status" style={{ width: "0.8rem", height: "0.8rem", borderWidth: "2px", }}>
                                <span class="visually-hidden">Loading...</span>
                            </span>
                            ) : (
                            <i className="ri-search-line"></i>
                            )}
                            </button>
                            {/* </TooltipComponent> */}
                        </div>
                      </div>
                       <div className='col-md-3'>
                            <TextBox type="Date" id="from_date" name="from_date" label="From Date" value={this.state.from_date} change={this.handleInputChange} />
                        </div>
                        <div className='col-md-3'>
                            <TextBox type="Date" id="to_date" name="to_date" label="To Date" value={this.state.to_date} change={this.handleInputChange} />
                        </div>
                        {/* <div className='col-md-3'>
                            <div className=" d-flex align-items-center gap-2"> */}
                                <div className='col-lg-2 col-md-3 col-6 '>
                                    <div><label>Apply Filter</label></div>
                                    {/* <button
                                        type="button"
                                        onClick={this.handleInputSearch}
                                        disabled={ !this.state.from_date && !this.state.to_date}
                                        className={`w-100 noWrap btn btn-info btn-label waves-effect waves-light`}>
                                        <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                        Filter
                                    </button> */}
                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "1"},()=>{this.handleInputSearch()})}} 
                                    disabled={!this.state.from_date && !this.state.to_date}
                                    loading={this.state.loadingFilter==="1"} loadingMessage='Loading' 
                                    buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                                </div>
                                <div className='col-lg-2 col-md-3 col-6 '>
                                    <div>
                                        <label className="noWrap">Clear Filter</label>
                                    </div>
                                    {/* <button
                                        type="button"
                                        disabled={!this.state.from_date && !this.state.to_date}
                                        className={`w-100 btn noWrap btn-secondary btn-label waves-effect waves-light`}
                                        onClick={this.handleClearAll}>
                                        <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> 
                                        Clear
                                    </button> */}
                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "2"},()=>{this.handleClearAll()})}} 
                                    disabled={!this.state.from_date && !this.state.to_date}
                                    loading={this.state.loadingFilter==="2"} loadingMessage='Loading' 
                                    buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />
                                </div>
                            {/* </div>
                        </div> */}
                        { this.state.decodedData?.includes(2) && ( 
                        <div className='col-lg-2 col-md-3 col-6 '>
                            <div><label>Claim Expense</label></div>
                            <SubmitButton otherClasses='w-100 noWrap' onClick={()=> this.setState({  applyModal:true, fileView:false, expense_description:'', })}
                            buttonName={ "Claim"} type='success' icon='ri-hand-coin-line' />
                        </div>)}
                        {/* <div className='col-md-3'>
                            <div className=" d-flex align-items-center gap-2">
                                <div className='col-md-6'>
                                    <div>
                                        <label>Export Excel</label>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={this.handleExcelDownload}
                                        className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-success btn-label waves-effect waves-light noWrap`}>
                                        <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                        Export Excel
                                    </button>
                                </div>
                            </div>
                        </div> */}
                    </div>
                  </div>
                  <div className="card-body">
                    <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                        <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                        <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                            <tr>
                            <th style={{ width:"5%"}} className="text-center">Sr.No.</th>
                            <th style={{ width:"10%"}} className="noWrap text-center">Claimed Date</th>
                            <th className="noWrap">Expense Title</th>
                            <th style={{ width:"10%"}} className="noWrap text-center">Expense Date</th>
                            <th style={{ width:"10%"}}>Status</th>
                            { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(3)) && ( 
                            <th  style={{ width:"10%"}} className="text-center">Action</th>)}
                            </tr>
                        </thead>
                        {this.state.rows.length === 0 ? (
                            <tbody>
                            <tr>
                                <td colSpan={11}>
                                <NoRecords />
                                </td>
                            </tr>
                            </tbody>
                        ) :
                            <tbody>
                            {this.state.rows.map((row,idx) => {
                                return (
                                    <tr key={row?.goal_id}>
                                        <td className="text-center">{idx+1}</td>
                                        <td className="noWrap">{row.created_date? formatDate(row.created_date):"--"}</td>
                                        <td>{row.expense_title}</td> 
                                        <td className="noWrap">{row.expense_date? formatDate(row.expense_date):"--"}</td>
                                        <td>
                                            <div
                                                style={{ fontSize: "0.65rem" }}
                                                className={`noWrap bg-${row?.ExpensesStatusClasses} text-white fw-semibold px-1 text-center py-1  rounded-4`}
                                            >
                                                {row?.ExpensesStatus}
                                            </div>
                                        </td> 
                                        { (this.state.decodedData?.includes(1)||this.state.decodedData?.includes(3))&& ( 
                                        <td>
                                            <div className="d-flex justify-content-around gap-2">
                                            { this.state.decodedData?.includes(1) && ( 
                                                <TooltipComponent name="View" position="bottom">
                                                    <button
                                                        onClick={() =>{
                                                            this.getInfo(row);
                                                        }}
                                                        type="button"
                                                        className="btn-icon btn btn-sm btn-outline-success mr-2 text-center"
                                                        > 
                                                        <i className="ri-file-info-line"></i>
                                                    </button>
                                                </TooltipComponent>)}
                                                { this.state.decodedData?.includes(3) && ( 
                                                <TooltipComponent name="Cancel" position="bottom">
                                                    <button
                                                        onClick={() =>{
                                                            this.handleCancel(row);
                                                        }}
                                                        disabled={row?.ExpensesStatus!=="Applied"}
                                                        type="button"
                                                        className="btn-icon btn btn-sm btn-outline-danger mr-2 text-center"
                                                        > 
                                                        <i className="ri-chat-delete-line"></i>
                                                    </button>
                                                </TooltipComponent>)}
                                                <TooltipComponent name="Logs" position="bottom">
                                                    <button
                                                        onClick={() =>{
                                                            if(!this.state.loadingLogs){
                                                                this.setState({loadingLogs:true},
                                                                    ()=>this.GetExpenseLogList(row))
                                                            }
                                                            
                                                        }}
                                                        type="button"
                                                        className="btn-icon btn btn-sm btn-outline-secondary mr-2 text-center"
                                                        > 
                                                         {this.state.loadingLogs ? (
                                                            <span
                                                                class="spinner-border flex-shrink-0"
                                                                role="status"
                                                                style={{
                                                                width: "0.8rem",
                                                                height: "0.8rem",
                                                                borderWidth: "2px",
                                                                }}
                                                            >
                                                                <span class="visually-hidden">
                                                                Loading...
                                                                </span>
                                                            </span>
                                                            ) : (
                                                            <i className="ri-file-text-line"></i>
                                                            )}
                                                    </button>
                                                </TooltipComponent>
                                                {/* <TooltipComponent name="Send For Review" position="bottom-left">
                                                    <button
                                                        onClick={() =>{
                                                            this.handleRating(row)
                                                        }}
                                                        type="button"
                                                        className="btn-icon btn btn-sm btn-outline-primary mr-2 text-center"
                                                        > 
                                                        <i className="ri-send-plane-fill"></i>
                                                    </button>
                                                </TooltipComponent> */}
                                            </div>
                                        </td>)}
                                    </tr>
                                );
                            })}
                            </tbody>}
                        </table>
                    </div>
                    <div className="d-flex justify-content-between bg-light align-items-center flex-wrap w-100 py-2 px-2" >
                        <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} 
                        type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}>
                            <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous
                        </button>
                        <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} 
                        type="button" onClick={() => this.handleNext()} className={`d-md-none d-block btn btn-primary btn-label waves-effect right waves-light`}>
                            <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next
                        </button>
                        <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                            {
                                <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                            }
                        </div>
                        <div className='col-md-2'>
                            <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                {Array.from({ length: this.state.total_pages }, (_, i) => (
                                    <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                {this.state.rows?.length>0 && (
                                    <option value={this.state.rows?.length}>
                                    All
                                    </option>
                                )}
                                {limitOptions.map((option) => (
                                    <option key={option} value={option}>
                                        Limit {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`d-md-block d-none btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                    </div>
                  </div>
                </div>
                {this.state.applyModal && (
                    <div className="modal show"  style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }} >
                        <div className=" m-auto mt-4 w-modal">
                            <div className="modal-content">
                            <div className="modal-header pb-0">
                                <h5 className="modal-title" id="exampleModalgridLabel">Claim Expense</h5>
                                <button type="button"
                                disabled={this.state.postLoading} className="btn-close" onClick={()=>{
                                this.setState({ expense_id:'', applyModal:false, fileView:false, expense_date: "", expense_amount: "", expense_description: "", expense_attachment: "", })
                                }} aria-label="Close" />
                            </div>
                            <div className="modal-body pt-0">
                                <div className="container mt-2">
                                <form className="row">
                                    <div className="col-md-6 mt-3">
                                        <label className="form-label">Expense</label>
                                            <Select  onChange={(selectOption) => this.setState({ expense_id: selectOption?.value })}
                                            options={this.state.expenseOptions}
                                            placeholder={`Select Expense`}
                                            value={ this.state.expense_id ? this.state.expenseOptions.find(option => option.value === this.state.expense_id) : null }
                                            isDisabled={this.state.fileView}/>
                                            {this.state.errors.expense_id && <div className="text-danger">{this.state.errors.expense_id}</div>}
                                    </div>                
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="expense_date" className="form-label">Expense Date</label>
                                        <input type="date" className={`form-control`} id="expense_date" name="expense_date" disabled={this.state.fileView} value={this.state.expense_date}
                                         onChange={(e) => this.handleInputChange(e)}/>
                                        {this.state.errors.expense_date && <div className="text-danger">{this.state.errors.expense_date}</div>}
                                    </div>                   
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="expense_amount" className="form-label">Expense Amount</label>
                                        <input type="number" className={`form-control`} id="expense_amount" name="expense_amount" disabled={this.state.fileView} value={this.state.expense_amount}
                                        onChange={(e) => this.handleInputChange(e)}
                                        placeholder="Enter Amount"/>
                                        {this.state.errors.expense_amount && <div className="text-danger">{this.state.errors.expense_amount}</div>}
                                    </div>    
                                    <div className='col-md-6 mb-md-3 mb-0 mt-3'>
                                        <label className="form-label">Attachment <span className='text-muted '>
                                            {/* {!formData?.fileData?.fileName && !this.state.fileView ? '(...Optional)': '(Not Attached)'} */}
                                            {formData?.file ? "(Document Attached)" : "(No Document Attached)"}
                                            </span></label>
                                        <div>
                                            <input type="file" id="employee_resignation_document" onChange={this.handleFileChange} style={{ display: "none" }} accept="image/jpeg, image/png, application/pdf"/>
                                            {!formData?.fileData?.fileName && !this.state.fileView && (
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <label className="btn btn-primary btn-label waves-effect waves-light" htmlFor="employee_resignation_document">
                                                            <i className="ri-file-line label-icon align-middle fs-16 me-2" />
                                                            Choose File
                                                        </label>
                                                        {errors?.file && <div className="text-danger">{errors.file}</div>}
                                                    </div>
                                                </div>
                                            )}
                                            <ul className="list-unstyled mb-0" style={{ display: formData?.file ? "block" : "none" }}>
                                                <li className=" dz-processing dz-error dz-complete">
                                                    <div className="border rounded">
                                                        <div className="d-flex p-2">
                                                            <div
                                                                className={`${!formData?.fileData?.fileDelete && formData?.file ? "cursorPointer" : ''} flex-shrink-0 me-3`}
                                                                onClick={() => {
                                                                    if (!formData?.fileData?.fileDelete && formData?.file) {
                                                                        this.setState({ viewDocument: true });
                                                                    }
                                                                }}
                                                            >
                                                                <div className="p-1 bg-light rounded d-flex align-items-center justify-content-center">
                                                                    <img style={{ width: "20px" }} src={formData?.fileData?.fileTypeIcon} alt="file icon" />
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1">
                                                                <div className="pt-1">
                                                                    <h5 className="fs-13 mb-1 text-ellipse">{formData?.fileData?.fileName}</h5>
                                                                    {/* <p className="fs-13 text-muted mb-0"><strong>{formData?.fileData?.fileSize}</strong></p> */}
                                                                </div>
                                                            </div>
                                                            {formData?.fileData?.fileDelete && (
                                                                <div className="flex-shrink-0 ms-3 d-flex justify-content-center align-items-center">
                                                                    <button
                                                                        type='button'
                                                                        onClick={this.handleDeleteImage}
                                                                        className="btn btn-sm btn-outline-danger"
                                                                    >
                                                                        <i className="ri-delete-bin-line"></i>
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>               
                                    <div className="col-md-12 mt-3">
                                        <label htmlFor="expense_description" className="form-label">Expense Description</label>
                                        <textarea 
                                            className={`form-control`}
                                            id="expense_description"
                                            name="expense_description"
                                            disabled={this.state.fileView}
                                            value={this.state.expense_description}
                                            onChange={(e) => this.handleInputChange(e)}
                                            placeholder="Write Description..."
                                        />
                                        {this.state.errors.expense_description && <div className="text-danger">{this.state.errors.expense_description}</div>}
                                    </div>
                                </form>
                                {!this.state.fileView && (
                                    <div className="col-md-12 mt-3 mb-3 d-flex justify-content-between align-items-center" >
                                        <SubmitButton onClick={this.handleSubmit} loading={this.state.postLoading}
                                        buttonName={"Claim"} loadingMessage='Loading' type='primary' icon='ri-hand-coin-line' />
                                        
                                        <SubmitButton disabled={this.state.postLoading} 
                                        onClick={()=>{
                                             this.setState({
                                                expense_id:'',
                                                applyModal:false,
                                                fileView:false,
                                                expense_date: "",
                                                expense_amount: "",
                                                expense_description: "",
                                                
                                            })
                                        }}
                                        buttonName="Cancel" type='secondary' icon='ri-close-line' /> 
                                </div>
                                )}
                                
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                )}
                {this.state.viewDocument && (
                    <div id="myModal" className="modal show" tabIndex={-1} style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}
                    aria-labelledby="myModalLabel" aria-hidden="true">
                        <div className=" bg-light m-auto mt-3 w-profilePic">
                        <div className="modal-content">
                            <div className="modal-header pb-0">
                                <h5 className="modal-title" id="myModalLabel">Attachment</h5>
                                <button onClick={() => { this.setState({viewDocument:false}); }} className="btn-close" aria-label="Close"/>
                            </div>
                            <div className="modal-body pt-0">
                            <div>
                                <div className="mb-4 m-auto p-1 rounded-2 grayBlurShadow">
                                <h3 className="text-center text-ellipse" >
                                    {formData?.fileData?.fileName || "--"}
                                </h3>
                                <div
                                    className="m-auto rounded-3 overflow-hidden"
                                    style={{
                                    width: "100%",
                                    height: "600px",
                                    border: "1px solid #ccc",
                                    }}
                                >
                                    {formData?.file && formData?.file?.includes("pdf") ? (
                                    <iframe
                                        src={formData?.file}
                                        title="PDF Viewer"
                                        style={{
                                        width: "100%",
                                        height: "100%",
                                        }}
                                        frameBorder="0"
                                    >
                                        This browser does not support embedded
                                        files.
                                    </iframe>
                                    ) : (
                                    formData?.file?
                                    <img
                                        src={formData?.file}
                                        style={{
                                        width: "100%",
                                        // height: "100%",
                                        }}
                                        alt="document_image"
                                    />:
                                    <p>Attachment Not Found!</p>
                                    )}
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                )}
                {this.state.viewEmployeeExpenseLogs && (
                    <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}  >
                    <div className="m-auto mt-4 w-modal">
                        <div className="modal-content">
                        <div className="modal-header pb-0">
                            <h5 className="modal-title" id="rmModalLabel">Employee Expense Log</h5>
                            <button type="button" className="btn-close" onClick={()=> this.setState({ viewEmployeeExpenseLogs:false })} aria-label="Close" />
                        </div>
                        <div className="modal-body pt-0">
                            <h5>Expense Title:  {this.state.viewEmployeeExpenseLogs} </h5>
                            <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                    <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                        <tr>
                                            <th style={{ width:"5%"}} className="text-center">Sr.No.</th>
                                            <th style={{ width:"8%"}} className="text-center">Date</th>
                                            {/* <th>Goal Title</th> */}
                                            <th style={{ width:"10%"}} className="text-center">Status</th>
                                            {/* <th style={{ width:"10%"}}  className="text-center noWrap">Employee Rating</th>
                                            <th style={{ width:"10%"}}  className="text-center noWrap">RM Rating</th>
                                            <th style={{ width:"5%"}} className="text-center">Grade</th> */}
                                            <th>Self Remark</th>
                                            <th>RM Remark</th>
                                            {/* <th  style={{ width:"10%"}} className="text-center">Status</th> */}
                                        </tr>
                                    </thead>
                                    {Array.isArray(this.state.employeeExpenseRows) && this.state.employeeExpenseRows.length === 0 ? (
                                        <tbody>
                                        <tr>
                                            <td colSpan={11}>
                                            <NoRecords />
                                            </td>
                                        </tr>
                                        </tbody>
                                    ) :
                                        <tbody>
                                        {Array.isArray(this.state.employeeExpenseRows) && this.state.employeeExpenseRows.map((row,idx) => {
                                            return (
                                            <tr key={row.employee_id}>
                                                <td className="text-center">{idx+1}</td>
                                                <td className="noWrap">{row.created_date? formatDateAndTime(row.created_date)?.split("T")[0]:"--"}</td>
                                                {/* <td>{row.goal_title}</td> */}
                                                <td><span className={`badge bg-${row?.ExpensesStatusClasses}`}>{row?.ExpensesStatus}</span></td>
                                                {/* <td className="text-center">{row?.goal_rating_employee || "--"}</td>
                                                <td className="text-center">{row?.goal_rating_rm || "--"}</td>
                                                <td className="text-center">{row?.goal_grade || "--"}</td> */}
                                                <td>{row?.employee_remarks || "--"}</td>
                                                <td>{row?.rm_remarks || "--"}</td>
                                            </tr>
                                            );
                                        })}
                                        </tbody>}
                                        {/* <tfoot className="table-light">
                                            <tr>
                                            <th colSpan={8}>
                                                <div className="d-flex justify-content-between">
                                                <button
                                                    disabled={
                                                    this.state.prev === false &&
                                                        this.state.loadingList === false
                                                        ? true
                                                        : false
                                                    }
                                                    type="button"
                                                    onClick={() => this.handlePrev()}
                                                    className={`btn btn-warning btn-label waves-effect waves-light`}
                                                >
                                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                    Previous
                                                </button>
                                                <div
                                                    className="col-md-4"
                                                    style={{ display: "flex", alignItems: "center" }}
                                                >
                                                    {
                                                    <small>
                                                        Total Records: {this.state.total_records} |
                                                        Total Pages: {this.state.total_pages} |
                                                        Current Page: {this.state.page}
                                                    </small>
                                                    }
                                                </div>
                                                <div className="col-md-2">
                                                    <select
                                                    className="form-select"
                                                    onChange={(e) => this.handleChange(e)}
                                                    >
                                                    {Array.from(
                                                        { length: this.state.total_pages },
                                                        (_, i) => (
                                                        <option
                                                            selected={this.state.page === i + 1}
                                                            key={i}
                                                            value={i + 1}
                                                        >
                                                            Page {i + 1}
                                                        </option>
                                                        )
                                                    )}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <select
                                                    className="form-select"
                                                    onChange={this.handleLimitChange}
                                                    value={this.state.limit}
                                                    >
                                                    {limitOptions.map((option) => (
                                                        <option key={option} value={option}>
                                                        Limit {option}
                                                        </option>
                                                    ))}
                                                    </select>
                                                </div>
                                                <button
                                                    disabled={
                                                    this.state.next === false &&
                                                        this.state.loadingList === false
                                                        ? true
                                                        : false
                                                    }
                                                    type="button"
                                                    onClick={() => this.handleNext()}
                                                    className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                >
                                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                    Next
                                                </button>
                                                </div>
                                            </th>
                                            </tr>
                                        </tfoot> */}
                                </table>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                )}
                {this.state.sendGoalModal && (
                    <div className="modal show"  style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }} >
                        <div className="m-auto mt-4 w-modal">
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalgridLabel">Send Goal For Review</h5>
                                <button type="button"
                                disabled={this.state.postLoading} className="btn-close" onClick={()=>{
                                    this.setState({
                                        sendGoalModal:false,
                                        goal_assign_id: "",
                                        goal_rating_employee: '',
                                        expense_description: '',
                                        pms_cycle_from_date: '',
                                        pms_cycle_to_date:  '',
                                        pms_cycle_start_date: '',
                                        pms_cycle_end_date: '',
                                    })
                                }} aria-label="Close" />
                            </div>
                            <div className="modal-body">
                                <div className="container mt-2">
                                <form className="row">
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="goal_title" className="form-label">Goal Title</label>
                                    <input
                                        type="text"
                                        className={`form-control`}
                                        id="goal_title"
                                        name="goal_title"
                                        disabled
                                        value={this.state.goal_title}
                                        onChange={(e) => this.handleInputChange(e)}
                                        placeholder="Enter Title"
                                    />
                                    {/* {this.state.errors.goal_title && <div className="text-danger">{this.state.errors.goal_title}</div>} */}
                                </div>
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="goal_title" className="form-label">PMS Cycle Dates</label>
                                    <div  className={`form-control`}>
                                        <span>
                                            {this.state.pms_cycle_start_date} <i className="ri-arrow-left-right-line" /> {this.state.pms_cycle_end_date}
                                        </span>
                                    </div>
                                    {/* {this.state.errors.goal_title && <div className="text-danger">{this.state.errors.goal_title}</div>} */}
                                </div>
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="goal_rating_employee" className="form-label">Self Rating <small className=" text-muted">(Out Of 100)</small>
                                        <span
                                            style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="number"
                                        className={`form-control`}
                                        id="goal_rating_employee"
                                        name="goal_rating_employee"
                                        value={this.state.goal_rating_employee}
                                        onChange={(e) => this.handleInputChange(e)}
                                        placeholder="Enter Rating"
                                    />
                                    {this.state.errors.goal_rating_employee && <div className="text-danger">{this.state.errors.goal_rating_employee}</div>}
                                </div>
                                <div className="col-md-6 mt-3">
                                <div className="row col-md-12">
                                    <div className='col-md-6'>
                                        <label htmlFor="pms_cycle_from_date" className="form-label">Goal Start date</label>
                                        <input
                                            type="text"
                                            className={`form-control`}
                                            id="pms_cycle_from_date"
                                            name="pms_cycle_from_date"
                                            disabled
                                            value={this.state.pms_cycle_from_date}
                                            // onChange={(e) => this.handleInputChange(e)}
                                            placeholder="Start Date"
                                        />                                    
                                    </div>
                                    <div className='col-md-6'>
                                        <label htmlFor="pms_cycle_to_date" className="form-label">Goal End date</label>
                                        <input
                                            type="text"
                                            className={`form-control`}
                                            id="pms_cycle_to_date"
                                            name="pms_cycle_to_date"
                                            disabled
                                            value={this.state.pms_cycle_to_date}
                                            // onChange={(e) => this.handleInputChange(e)}
                                            placeholder="End Date"
                                        />                                    
                                    </div>
                                </div>
                                    
                                </div>
                                <div className="col-md-12 mt-3">
                                    <label htmlFor="expense_description" className="form-label">Remark
                                        <span
                                            style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                            *
                                        </span>
                                    </label>
                                    <textarea 
                                        className={`form-control`}
                                        id="expense_description"
                                        name="expense_description"
                                        value={this.state.expense_description}
                                        onChange={(e) => this.handleInputChange(e)}
                                        placeholder="Write Remark..."
                                    />
                                    {this.state.errors.expense_description && <div className="text-danger">{this.state.errors.expense_description}</div>}
                                </div>
                                </form>
                                <div className="col-md-12" style={{ marginTop: "30px" }}>
                                    {!this.state.postLoading ?
                                            <button
                                            disabled={!this.state.goal_rating_employee || !this.state.expense_description}
                                            className={`btn noWrap btn-primary btn-label waves-effect waves-light `}
                                            onClick={()=>{
                                                if(!this.state.postLoading){
                                                    this.setState({postLoading:true},
                                                        ()=>{
                                                            this.handleSubmit()
                                                        }
                                                    ); 
                                                }
                                            }}
                                            >
                                                <i className={`ri-send-plane-line label-icon align-middle fs-16`} />{"Send"}
                                            </button> :
                                            <button className="btn btn-primary btn-load">
                                                <span className="d-flex align-items-center">
                                                    <span className="spinner-border flex-shrink-0" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </span>
                                                    <span className="flex-grow-1 ms-2">
                                                        Sending...
                                                    </span>
                                                </span>
                                            </button>
                                        }
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(MyExpense);
